<template>
  <el-container class="app-wrapper">
    <!-- 侧边栏 -->
    <el-aside :width="isCollapse ? '64px' : '200px'" class="sidebar-container">
      <div class="logo-container">
        <img src="@/assets/logo.png" alt="Logo" class="logo-img">
      </div>

      <el-menu :default-active="activeMenu" :collapse="isCollapse" class="sidebar-menu" background-color="#ffffff" text-color="#606266"
        active-text-color="#CD3E3E" router>
        <el-menu-item index="/dataBoard">
          <i class="el-icon-s-platform"></i>
          <span slot="title">数据看板</span>
        </el-menu-item>
        <el-menu-item index="/assessment">
          <i class="el-icon-document"></i>
          <span slot="title">评估明细表</span>
        </el-menu-item>

        <el-menu-item index="/auction">
          <i class="el-icon-tickets"></i>
          <span slot="title">拍卖明细</span>
        </el-menu-item>

        <el-menu-item index="/dealer">
          <i class="el-icon-s-shop"></i>
          <span slot="title">特约店报表</span>
        </el-menu-item>

        <el-menu-item index="/platform">
          <i class="el-icon-s-platform"></i>
          <span slot="title">拍卖平台报表</span>
        </el-menu-item>
        <el-menu-item index="/downLoad">
          <i class="el-icon-download"></i>
          <span slot="title">报表下载</span>
        </el-menu-item>

        <el-menu-item index="/store">
          <i class="el-icon-s-home"></i>
          <span slot="title">特约店管理</span>
        </el-menu-item>

        <el-menu-item index="/users">
          <i class="el-icon-user"></i>
          <span slot="title">用户管理</span>
        </el-menu-item>
      </el-menu>
    </el-aside>

    <!-- 主容器 -->
    <el-container class="main-container">
      <!-- 头部 -->
      <el-header height="60px" class="header">
        <div class="header-left">
          <i class="el-icon-s-fold toggle-sidebar-btn" @click="toggleSidebar"></i>
          <breadcrumb />
        </div>

        <div class="header-right">
          <el-dropdown trigger="click" @command="handleCommand">
            <span class="user-info">
              <img src="https://cube.elemecdn.com/0/88/03b0d39583f48206768a7534e55bcpng.png" class="avatar">
              <span class="username">{{ username }}</span>
              <i class="el-icon-caret-bottom"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="profile">个人信息</el-dropdown-item>
              <el-dropdown-item command="logout">退出登录</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </el-header>

      <!-- 内容区 -->
      <el-main class="app-main">
        <router-view />
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import { logout } from '@/api/user'
import { clearAuth, getUserInfo } from '@/utils/auth'

// 面包屑组件
const Breadcrumb = {
  render(h) {
    return h('div', { class: 'breadcrumb' }, [
      h('span', {}, this.$route.meta.title || '首页')
    ])
  }
}

export default {
  name: 'AppLayout',
  components: {
    Breadcrumb
  },
  data() {
    return {
      username: '',
      isCollapse: false
    }
  },
  computed: {
    activeMenu() {
      return this.$route.path
    }
  },
  created() {
    // 获取用户信息
    const userInfo = getUserInfo()
    if (userInfo) {
      this.username = userInfo.realName || userInfo.username
    }
  },
  methods: {
    toggleSidebar() {
      this.isCollapse = !this.isCollapse
    },
    async handleCommand(command) {
      if (command === 'logout') {
        try {
          await logout()
          clearAuth()
          this.$message.success('退出成功')
          this.$router.push('/login')
        } catch (error) {
          this.$message.error('退出失败')
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.app-wrapper {
  height: 100%;
}

.sidebar-container {
  background-color: #ffffff;
  transition: width 0.3s;
  overflow: hidden;

  .logo-container {
    width: 100%;
    height: 60px;
    padding: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #ffffff;
    overflow: hidden;

    .logo-img {
      width:100%;
      margin-right: 10px;
      transition: all 0.3s;
    }

    .logo-title {
      color: #fff;
      font-size: 16px;
      font-weight: bold;
      margin: 0;
    }
  }

  .sidebar-menu {
    border-right: none;
    &.el-menu--collapse {
      width: 64px;
    }
  }
}

.main-container {
  height: 100%;
  flex-direction: column;
}

.header {
  background-color: #fff;
  border-bottom: 1px solid #e6e6e6;
  box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;

  .header-left {
    display: flex;
    align-items: center;

    .toggle-sidebar-btn {
      font-size: 20px;
      cursor: pointer;
      margin-right: 15px;
    }

    .breadcrumb {
      font-size: 14px;
      color: #606266;
    }
  }

  .header-right {
    .user-info {
      display: flex;
      align-items: center;
      cursor: pointer;

      .avatar {
        width: 28px;
        height: 28px;
        border-radius: 50%;
        margin-right: 8px;
      }

      .username {
        font-size: 14px;
        color: #606266;
      }

      .el-icon-caret-bottom {
        margin-left: 5px;
        font-size: 12px;
      }
    }
  }
}

.app-main {
  background-color: #f0f2f5;
  padding: 20px;
  overflow-y: auto;
}
</style>